import { render } from "./verify.html?vue&type=template&id=63bd75c2&scoped=true&external"
import script from "./verify.vue?vue&type=script&lang=js"
export * from "./verify.vue?vue&type=script&lang=js"

import "./verify.vue?vue&type=style&index=0&id=63bd75c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bd75c2"]])

export default __exports__